import { gql } from '@common/hooks';

export const WorksOrganizationBusinessesQuery = gql`
  query PaginatedWorksListItemsFilterData {
    organizationBusinesses {
      id
      name
    }
  }
`;
